module.exports = __webpack_public_path__ + "img/img58.9da3654d.svg";